import {promptBridgeApi} from '@dms/api/base';

import {
  supplierPartsSearchRequestSchema,
  supplierPartsSearchResponseSchema,
  type SupplierPartsSearchRequest,
  type SupplierPartsSearchResponse,
} from '@prompt-bridge/shared/validations';

export const supplierPartsApi = promptBridgeApi.injectEndpoints({
  endpoints: (build) => ({
    searchSupplierParts: build.query<SupplierPartsSearchResponse, SupplierPartsSearchRequest>({
      query: (queryArg) => ({
        url: '/api/v1/supplier-parts/search',
        method: 'POST',
        headers: {'X-Branch': queryArg.branchId},
        body: queryArg,
        queryArg,
      }),
      providesTags: ['PromptBridgeHondaPart', 'PromptBridgeNissanPart'],
      extraOptions: {
        requestSchema: supplierPartsSearchRequestSchema,
        responseSchema: supplierPartsSearchResponseSchema,
      },
    }),
  }),
});

export const {useSearchSupplierPartsQuery, useLazySearchSupplierPartsQuery} = supplierPartsApi;
